import { useContext } from 'react';

import { CurrentDraftContext } from '../context/CurrentDraftContext';

export const useCurrentDraft = () => useContext(CurrentDraftContext);
